import React from 'react';
import PropTypes from 'prop-types';

export default function Loader(props) {
	
	var styles = {};

	if (props.scrollToTop) {
		$('html, body').animate({
				scrollTop: $('.st-main-content').offset().top - 20
		});
	}

	var styles = {};
	var noPaddingOrMargin = {};
	var pageStickySpinner = {};

	if (props.center){
		styles = {
			display: 'flex',
		    flexDirection: 'column',
		    justifyContent: 'center',
		    alignItems: 'center',
			padding: 0,
		}	
		
		// applied to icon to get absolute center.
		noPaddingOrMargin = {
			padding: 0,
			margin: 0
		}
	}
	
	if (props.modal) {
		styles = {
			display: 'flex',
		    flexDirection: 'column',
		    justifyContent: 'center',
		    alignItems: 'center',
			padding: 0,
			opacity: 1,
			height: 'auto',
			position: 'relative'
		}	
	}

	if(props.pageStickySpinner) {
		pageStickySpinner = {
			position: 'sticky',
			top:'55vh',
		};
	}
	
	if(props.scrollToSelector){
		$('html, body').animate({
			scrollTop: $(props.scrollToSelector).offset().top - 100
		},600);
	}

	if (props.pastDelay) {
		return (
				<div style={{...styles, ...props.style}} className={`loader react-loader react-component-loader ${props.customStyles}`}>
					<div style={{...(props.pageStickySpinner ? pageStickySpinner : null)}} >
						{props.showLoadingText && <div>{props.loadingText ? props.loadingText : 'Loading...'}</div>}
						<i style={props.center ? noPaddingOrMargin : null} className={`far fa-spin ${props.icon} ${props.size}`} />
						<h4 className="font-weight-light mt-3">{props.children}</h4>
					</div>
				</div>
		);
	}

	return null;
}

Loader.propTypes = {
	icon: PropTypes.string,
	size: PropTypes.string,
	showLoadingText: PropTypes.bool,
	loadingText: PropTypes.string,
	customStyles: PropTypes.string,
	scrollToTop: PropTypes.bool,
	pastDelay: PropTypes.bool,
};

Loader.defaultProps = {
	icon: 'fa-spinner',
	size: '',
	showLoadingText: false,
	loadingText: '',
	customStyles: '',
	scrollToTop: false,
	pastDelay: true,
};
